import { BaseDto } from '@ideapa/common-dto';

import { createActionsFactory } from './actions';
import { createInitialStateFactory } from './initialState';
import { createReducerFactory } from './reducer';
import { createSelectorsFactory } from './selectors';

export function createSharedState<Entity extends BaseDto>(entityName: string) {
  const selectorsFactory = createSelectorsFactory<Entity>();

  const actionsFacory = createActionsFactory<Entity>(entityName);

  const stateFactory = createInitialStateFactory<Entity>();

  const reducerFactory = createReducerFactory<Entity>();

  return {
    ...selectorsFactory,
    ...actionsFacory,
    ...reducerFactory,
    ...stateFactory,
  };
}
